/*eslint backbone/no-constructor:0 */
define('glu/grid/filter/fieldSearch',['require','../../layout','../../util','../../collection','../../locale','hbs!./fieldSearch.hbs'],function(require) {
    'use strict';

    var Layout = require('../../layout'),
        util = require('../../util'),
        Collection = require('../../collection'),
        locale = require('../../locale'),
        tpl = require('hbs!./fieldSearch.hbs');

    function filterableColumns(column) {
        return column.get('filterable') !== false;
    }

    return Layout.extend({
        template: tpl,

        ui: {
            $focusField: 'input[type=text]',
            $submitBtn: '[type=submit]',
            $clearBtn: '.btn-clear-filter',
            $fieldSelect: '[name="field-name"]',
            $fieldValue: '[name="field-value"]',
            $enumSelect: '.search-input-wrapper select',
            $removeBtn: 'button[data-control="removeFilter"]'
        },

        events: {
            'submit': 'handleSubmit',
            'click @ui.$removeBtn': 'handleRemoveFilter',
            'click @ui.$clearBtn': 'handleClearFilter',
            'change @ui.$focusField': 'getSelectValue',
            'keyup @ui.$focusField': 'getSelectValue'
        },

        constructor: function(opts) {
            Layout.prototype.constructor.call(this, opts);
            if (opts && opts.model) {
                this.setField(opts.model.get('field'));
            }
            this.first = false;
            if (opts) {
                this.first = opts.first || false;
            }
        },


        disable: function() {
            this.disabled = true;
            this.setDisabledFromProperty();
        },

        enable: function() {
            this.disabled = false;
            this.setDisabledFromProperty();
        },

        setDisabledFromProperty: function() {
            this.ui.$focusField.removeAttr('disabled');
            this.ui.$submitBtn.removeAttr('disabled');
            this.ui.$clearBtn.removeClass('hidden');
            this.ui.$fieldSelect.removeAttr('disabled');
        },

        toggle: function() {
            return this.isDisabled() ? this.enable() : this.disable();
        },

        isDisabled: function() {
            return this.disabled === true;
        },

        focus: function() {
            util.defer(util.bind(function() {
                if (this.isClosed) {
                    return;
                }
                this.ui.$focusField.focus();
            }, this));
        },

        serializeData: function() {
            var items;
            if (this.model && this.collection) {
                items = new Collection(this.collection.filter(filterableColumns));
                var obj = this.model.toJSON();
                obj.items = items.toJSON();
                return obj;
            } else if (this.collection) {
                items = new Collection(this.collection.filter(filterableColumns));
                return {
                    items: items.toJSON()
                };
            } else {
                return Layout.prototype.serializeData.call(this);
            }
        },

        filterBy: function(field, value) {
            if (this.model.get('field') !== field) {
                return;
            }

            var filter = !util.isNullOrUndefined(value.equality) ? this.buildRangeFilter(field, value) : this.buildFilter(field, value);
            try {
                this.trigger('filter', filter);
            } catch (ex) {
                return false;
            }
            return false;
        },

        buildRangeFilter: function(field, value) {
            if (util.isArray(value.value)) {
                return this.buildFilter(value.value[0], value.equality, value.value[1]);
            } else {
                return this.buildFilter(value.value, value.equality);
            }
        },

        handleRemoveFilter: function() {
            this.trigger('filter:remove', this);
        },

        handleSubmit: function(e) {
            e.preventDefault();

            var form = e.target;
            var field = this.model.get('field');
            var value = form['field-value'].value;
            var filter = this.buildFilter(field, value);
            try {
                this.trigger('filter', filter);
            } catch (ex) {
                return false;
            }
            return false;
        },

        createFilter: function() {
            var fieldValue = this.ui.$focusField.val() || this.ui.$enumSelect.val(),
                field = this.model.get('field'),
                isEnum = this.model.get('type') === 'enum';

            if (isEnum) {
                fieldValue = this.dropdown.value('id')[0];
            }

            return this.buildFilter(field, fieldValue);
        },

        buildFilter: function(field, value) {

            var isFormatFunction = util.isFunction(this.model.get('format'));
            return {
                title: this.model.get('title'),
                value: value,
                label: value,
                type: this.model.get('type') || 'string',
                field: field || this.field,
                filter: util.bind(this.filter, this, this.field || field, value)
            };
        },

        onRender: function() {
            this.getSelectValue();
        },

        setField: function(field) {
            this.field = field;
            this.className = this.className || 'field-set';
        },

        unsetField: function() {
            delete this.field;
        },

        filter: function(field, value, model) {
            return model.get(field) === value;
        },

        getSelectValue: function() {
            var selection = this.ui.$fieldValue.val();
            this.handleSubmitButton(selection);
        },

        handleSubmitButton: function(selection) {
            this.ui.$submitBtn.prop('disabled', !selection);
            this.ui.$clearBtn.toggleClass('hidden', !selection);
            return selection;
        },

        handleClearFilter: function(e) {
            e.preventDefault();

            this.trigger('filter:clear', this);
        }
    });
});

